// extracted by mini-css-extract-plugin
export default {"gallery":"c-m_gX","gallery__header":"c-m_gY","gallery__thumbs":"c-m_gZ"};